module.exports = __webpack_public_path__ + "img/preview-11.e406463b.png";